// src/components/registration/utils/validation.js
const validate = (userGroups) => {
  let isValid = true;
  const errors = {};

  userGroups.forEach((group, groupIndex) => {
    // Group name
    if (!group.groupName.trim()) {
      isValid = false;
      errors[`groupName_${groupIndex}`] = "Group name is required.";
    }

    group.roles.forEach((role, roleIndex) => {
      // Role name
      if (!role.roleName.trim()) {
        isValid = false;
        errors[`roleName_${groupIndex}_${roleIndex}`] =
          "Role name is required.";
      } else {
        // Check for duplicate role names within the group
        const duplicate = group.roles.filter(
          (r, idx) =>
            r.roleName.trim() === role.roleName.trim() && idx !== roleIndex
        );
        if (duplicate.length > 0) {
          isValid = false;
          errors[`roleName_${groupIndex}_${roleIndex}`] =
            "Duplicate role name.";
        }
      }

      // Instead of `role.email`, we now check role.users
      if (!role.users || role.users.length === 0) {
        // require at least one user?
        isValid = false;
        errors[`users_${groupIndex}_${roleIndex}`] =
          "At least one user is required in this role.";
      } else {
        // Validate each user's format if you want
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        role.users.forEach((userEmail, uIndex) => {
          if (!emailRegex.test(userEmail.trim())) {
            isValid = false;
            errors[
              `users_${groupIndex}_${roleIndex}_u${uIndex}`
            ] = `Invalid email format for ${userEmail}`;
          }
        });
      }
    });
  });

  return { isValid, errors };
};

export default validate;
